import { useRequestData } from 'wsm-common-data';
import { formatNumber } from 'ddc-intl';

export default function useFormatNumber() {
	const { locale } = useRequestData();
	return (number) => formatNumber(number, locale);
}
